import type { RunState } from '../app/state';

export interface Stats { voyages: number; fell: number; held: number; avgGapSeconds: number; briefingCorrect: number; debriefCorrect: number; }

/** Store a finished run. Failures are silent: the voyage never depends on the server. */
export async function postRun(run: RunState): Promise<boolean> {
  try {
    const r = await fetch('/api/runs', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(run) });
    return r.ok;
  } catch { return false; }
}

/** A reply to the letter. Goes only to the author. */
export async function postReply(r: { clientId: string; name: string; message: string }): Promise<boolean> {
  try {
    const res = await fetch('/api/replies', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(r) });
    return res.ok;
  } catch { return false; }
}

export async function getStats(): Promise<Stats | null> {
  try { const r = await fetch('/api/stats'); if (!r.ok) return null; return (await r.json()) as Stats; } catch { return null; }
}
